module.exports = __webpack_public_path__ + "img/pc_footer_img2.bed889f.webp";